// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__j9HL_","content":"styles_content__-Hp3l"};